import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { OrganisationSubscriptionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createOrganisationSubscription = (data): any => action(types.CREATE_ORGANISATION_SUBSCRIPTION_REQUESTED, data);

export const updateOrganisationSubscription = (data): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_REQUESTED, data);

export const deleteOrganisationSubscription = (organisationSubscriptionId): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_REQUESTED, organisationSubscriptionId);

export const getOrganisationSubscription = (organisationSubscriptionId): any => action(types.GET_ORGANISATION_SUBSCRIPTION_REQUESTED, organisationSubscriptionId);

export const getAllOrganisationSubscriptions = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_ORGANISATION_SUBSCRIPTIONS_REQUESTED, {
  pagination,
  compile,
});

export const selectOrganisationSubscription = (organisationSubscriptionId): any => action(types.SELECT_ORGANISATION_SUBSCRIPTION_REQUESTED, {
  currentOrganisationSubscriptionId: organisationSubscriptionId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createOrganisationSubscriptionPending: (payload): any => action(types.CREATE_ORGANISATION_SUBSCRIPTION_PENDING, payload),
  createOrganisationSubscriptionSuccess: (response): any => {
    const currentOrganisationSubscription = response.entities.organisationSubscriptions[response.result];
    // history.push(`/payment/${currentOrganisationSubscription.paymentCollection.id}/review`);
    return action(types.CREATE_ORGANISATION_SUBSCRIPTION_SUCCESS, {
      organisationSubscriptionsById: response.entities.organisationSubscriptions,
      currentOrganisationSubscriptionId: response.result,
    });
  },
  updateOrganisationSubscriptionPending: (payload): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_PENDING, payload),
  updateOrganisationSubscriptionSuccess: (response): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_SUCCESS, {
    organisationSubscriptionsById: response.entities.organisationSubscriptions,
    currentOrganisationSubscriptionId: response.result,
  }),
  updateOrganisationSubscriptionFailed: (error): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationSubscriptionPending: (): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_PENDING, {}),
  deleteOrganisationSubscriptionSuccess: (response, userId): any => {
    localStorage.set(userId, { currentOrganisationSubscriptionId: null });
    history.push('/organisationSubscriptions');

    return action(types.DELETE_ORGANISATION_SUBSCRIPTION_SUCCESS, {
      currentOrganisationSubscriptionId: response,
    });
  },
  getOrganisationSubscriptionPending: (): any => action(types.GET_ORGANISATION_SUBSCRIPTION_PENDING, {}),
  getOrganisationSubscriptionSuccess: (response): any => action(types.GET_ORGANISATION_SUBSCRIPTION_SUCCESS, {
    organisationSubscriptionsById: response.entities.organisationSubscriptions,
    currentOrganisationSubscriptionId: response.result,
  }),
  getOrganisationSubscriptionFailed: (error): any => action(types.GET_ORGANISATION_SUBSCRIPTION_FAIL, {
    backendErrors: error,
  }),
  deleteOrganisationSubscriptionFailed: (error): any => action(types.UPDATE_ORGANISATION_SUBSCRIPTION_FAIL, {
    backendErrors: error,
  }),
  getAllOrganisationSubscriptionsPending: (pagination): any => action(types.GET_ALL_ORGANISATION_SUBSCRIPTIONS_PENDING, { pagination }),
  getAllOrganisationSubscriptionsSuccess: (response, meta): any => action(types.GET_ALL_ORGANISATION_SUBSCRIPTIONS_SUCCESS, {
    organisationSubscriptionsById: response.entities.organisationSubscriptions,
    organisationSubscriptionIds: response.result,
    meta,
  }),
  getAllOrganisationSubscriptionsFailed: (error): any => action(types.GET_ALL_ORGANISATION_SUBSCRIPTIONS_FAIL, {
    backendErrors: error,
  }),
  createOrganisationSubscriptionFailed: (error): any => action(types.CREATE_ORGANISATION_SUBSCRIPTION_FAIL, {
    backendErrors: error,
  }),
};

export default null;
